// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__eEu0Y"};